import React from 'react';
import Button from '../button';
const OrderConfirmation = props => {
   const { order, userEmail, onClose } = props;
   return (
      <div className="justify-center align-center text-center">
         <h3 className="color-white quicksand text-center">
            ¡Pedido realizado con éxito!
         </h3>
         <h4 className="color-white quicksand text-center">
            Tu folio es: <span className="color-red">{order}</span>
         </h4>
         <div className="white-space-16"></div>
         <p className="color-white confirmation-text">
            Se ha enviado un email al correo{' '}
            <span className="color-red" style={{ fontWeight: 700 }}>
               {userEmail}
            </span>{' '}
            con las instrucciones para pagar y recibir su compra (si no lo
            recibió, por favor revise su carpeta de spam).
         </p>
         <p className="color-white confirmation-text">
            ¡Muchas gracias por su confianza! Contáctenos en caso de dudas.
         </p>
         <div className="white-space-16"></div>
         <Button onClick={onClose}>Aceptar</Button>
      </div>
   );
};

export default OrderConfirmation;



// WEBPACK FOOTER //
// ./src/components/Modals/order-confirmation.js